import { useState, useContext } from "react";
import { VegaButtonLink } from "@heartlandone/vega-react";
import { VegaNotify } from "@heartlandone/vega";
import FeedbackPopup from "Components/AddFeedbackPopup/FeedbackPopup";
import { PATH } from "Chore/Apis";
import { _fetch } from "Chore/Request";
import { toggleGlobalModalAction } from 'Redux/Actions/actions';
import { HubContext } from 'Redux/Context/context';

const { GET_ACTIVITY } = PATH;

function ViewFeedbackAction({ activity }) {
  const { id } = activity;
  const [isViewFeedbackOpen, setIsViewFeedbackOpen] = useState(false);
  const [feedbackDetail, setFeedbackDetail] = useState(null);
  const { globalModalDispatch } = useContext(HubContext);

  const _onViewFeedbackClick = () => {
    _toggleModal(true);
    _fetch({
      api: `${GET_ACTIVITY}/${id}/myfeedback`,
      method: "GET",
    }).then((res) => {
      if (res.code === 2200) {
        setFeedbackDetail(res?.payload);
        setIsViewFeedbackOpen(true);
      } else {
        VegaNotify.open({
          type: "error",
          message: res.message,
        });
      }
    }).finally(() => {
      _toggleModal();
    });
  };
  const _toggleModal = (isShow = false) => {
    globalModalDispatch(toggleGlobalModalAction({isShow}));
  }

  return (
    <>
      <VegaButtonLink
        label="View Feedback"
        icon="fa-regular fa-eyes"
        onVegaClick={() => _onViewFeedbackClick()}
      />
      <FeedbackPopup
        activityId={id}
        isOpen={isViewFeedbackOpen}
        currenFeedBack={feedbackDetail}
        onClose={() => {
          setIsViewFeedbackOpen(false);
        }}
      />
    </>
  );
}

export default ViewFeedbackAction;
